import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchNoToken, fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLoadingConfigurations } from "./configurationActions";
import { startGetRolesByUserId_Step2, clearActiveSpecialistRoleOnLogout } from "./userRoleActions";
import { t } from "i18next";
import { setIsReLoadingMenuFromUrl } from "./menuActions";
import { startGetRolesMenusByUserId } from "./optimizationActions";
import { startLoadingHomeContentItems } from "./homeContentActions";
import { selectUserForPreferences } from "./userActions";
import { debugLogActions } from "../helpers/debugHelper";
import { buildLoginContext } from "../helpers/intentTrackingHelper";

export const startLogin_Steps = (email, password, id_generated) => {
  return async (dispatch) => {

    const resp = await fetchNoToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_AUTH}`,
      "login",
      { email, password, id_generated, login_context: buildLoginContext() },
      "POST"
    );
    const body = await resp.json();

    if (body.ok) {
      localStorage.setItem("token", body.token);
      localStorage.setItem("token-init-date", new Date().getTime());

      dispatch(
        login({
          user_id: body.id,
          first_name: body.first_name,
          last_name: body.last_name,
          user_name: body.user_name,
        })
      );

      dispatch(startGetRolesByUserId_Step2(body.id));

      dispatch(startLoadingConfigurations());

    } else {

      if (body.errors) {
        const { email } = body.errors;

        if (email) {
          Swal.fire(t("titles.error"), email.msg, "error");
          dispatch(startLogout());
        }
      }

      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      } if (body.code === "bak-error-usu-001") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-error-usu-001"), "error");
        
      }
       if (body.code === "bak-error-usu-002") {
        dispatch(promptResendOnLogin(email, id_generated, body));
        
      }
      if (body.code === "bak-error-usu-005") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-error-usu-005"), "error");
      }
      if (body.code === "bak-error-pass-001") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-error-pass-001"), "error");
        
      }
      if (body.code === "bak-error-conn-001") {
       Swal.fire(t("titles.error"), t("alerts.validation.bak-error-conn-001"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

export const startLogin_Unified = (email, password, id_generated, navigate) => {
  return async (dispatch) => {

    const resp = await fetchNoToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_AUTH}`,
      "login",
      { email, password, id_generated, login_context: buildLoginContext() },
      "POST"
    );
    const body = await resp.json();

     debugLogActions(':: authActions, startLogin_Unified', { 'body': body });

    if (body.ok) {
      localStorage.setItem("token", body.token);
      localStorage.setItem("token-init-date", new Date().getTime());

      dispatch(
        login({
          user_id: body.id,
          first_name: body.first_name,
          last_name: body.last_name,
          user_name: body.user_name,
        })
      );

      navigate("/dashboard");
      
      dispatch(startGetRolesMenusByUserId(body.id));
      
      dispatch(selectUserForPreferences(body.user));
      
      dispatch(startLoadingConfigurations());
      dispatch(startLoadingHomeContentItems());

    } else {

      if (body.errors) {
        const { email } = body.errors;

        if (email) {
          Swal.fire(t("titles.error"), email.msg, "error");
          dispatch(startLogout());
        }
      }

      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      } if (body.code === "bak-error-usu-001") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-error-usu-001"), "error");
        
      
      } if (body.code === "bak-error-usu-002") {
        dispatch(promptResendOnLogin(email, id_generated, body));
        
      }
      if (body.code === "bak-error-usu-005") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-error-usu-005"), "error");
      }
      if (body.code === "bak-error-pass-001") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-error-pass-001"), "error");
        
      }
      if (body.code === "bak-error-conn-001") {
       Swal.fire(t("titles.error"), t("alerts.validation.bak-error-conn-001"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

export const startRegister = (user, id_generated) => {
  return async (dispatch) => {
    const resp = await fetchNoToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_AUTH}`,
      "addNT",
      { ...user, id_generated },
      "POST"
    );
    const body = await resp.json();

     debugLogActions(':: authActions, startRegister', { 'body': body });

    if (body.ok) {
      localStorage.setItem("token", body.token);
      localStorage.setItem("token-init-date", new Date().getTime());

      dispatch(
        login({
          user_id: body.id,
          first_name: body.first_name,
          last_name: body.last_name,
          user_name: body.user_name,
        })
      );
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

export const startRegisterUserAndRoleClient = (user, id_generated) => {
  return async (dispatch) => {
    const resp = await fetchNoToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_AUTH}`,
      "addUserAndRoleClientNT",
      { ...user, id_generated },
      "POST"
    );
    const body = await resp.json();

     debugLogActions(':: authActions, startRegisterUserAndRoleClient', { 'body': body });

    if (body.ok) {
      Swal.fire(t('alerts.titles.success'), t('alerts.operation.user-register'), "success");

      dispatch(successRegisterUser());
      

    } else {
      if (body.errors) {
        const messages = Object.values(body.errors)
          .map((item) => item && item.msg)
          .filter(Boolean);
        if (messages.length > 0) {
          Swal.fire(t("titles.error"), messages.join("\n"), "error");
        }
      }
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-error-usu-003") {
        Swal.fire({
          title: t("titles.error"),
          text: t("alerts.validation.bak-error-usu-003"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: t("alerts.validation.bak-error-usu-003-yes"),
          cancelButtonText: t("buttons.cancel"),
        }).then((result) => {
          if (result.isConfirmed) {
            dispatch(startResendConfirmation(user.email, id_generated, "register", user.password));
          }
        });
      }
      if (body.code === "bak-error-usu-004") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-error-usu-004"), "error");
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const promptResendOnLogin = (email, id_generated, body) => {
  return (dispatch) => {
    if (body.resend_enabled) {
      Swal.fire({
        title: t("titles.error"),
        text: t("alerts.validation.bak-error-usu-002-resend"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: t("alerts.validation.bak-error-usu-003-yes"),
        cancelButtonText: t("buttons.cancel"),
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(startResendConfirmation(email, id_generated, "login"));
        }
      });
      return;
    }
    Swal.fire(t("titles.error"), t("alerts.validation.bak-error-usu-002"), "error");
  };
};

export const startResendConfirmation = (email, id_generated, origin, password) => {
  return async () => {
    const payload = { email, id_generated, origin };
    if (password) {
      payload.password = password;
    }
    const resp = await fetchNoToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_AUTH}`,
      "resend-confirmation",
      payload,
      "POST"
    );
    const body = await resp.json();

    debugLogActions(":: authActions, startResendConfirmation", { body });

    if (body.ok && body.already_sent) {
      Swal.fire(t("alerts.titles.success"), t("alerts.operation.resend-confirmation-recent"), "info");
      return;
    }
    if (body.ok) {
      Swal.fire(t("alerts.titles.success"), t("alerts.operation.resend-confirmation"), "success");
      return;
    }
    if (body.code === "bak-error-usu-004") {
      Swal.fire(t("titles.error"), t("alerts.validation.bak-error-usu-004"), "error");
      return;
    }
    if (body.code === "bak-error-resend-001") {
      Swal.fire(t("titles.error"), t("alerts.validation.bak-error-resend-001"), "error");
      return;
    }
    if (body.code === "bak-error-mail-001") {
      Swal.fire(t("titles.error"), t("alerts.validation.bak-error-mail-001"), "error");
      return;
    }
    if (body.errors) {
      const messages = Object.values(body.errors)
        .map((item) => item && item.msg)
        .filter(Boolean);
      if (messages.length > 0) {
        Swal.fire(t("titles.error"), messages.join("\n"), "error");
      }
      return;
    }
    if (body.code === "bak-error-001") {
      Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");
    }
  };
};

export const startForgotPasswordProcess = (email, id_generated) => {
  return async (dispatch) => {

    const resp = await fetchNoToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_AUTH}`,
      "forgot-password",
      { email, id_generated },
      "POST"
    );
    const body = await resp.json();

     debugLogActions(':: authActions, startForgotPasswordProcess', { 'body': body });

    if (body.ok) {
      Swal.fire(t('alerts.titles.success'), t('alerts.operation.forgot-password'), "success");
    } else {

      if (body.errors) {
        const { email } = body.errors;

        if (email) {
          Swal.fire(t("titles.error"), email.msg, "error");
          dispatch(startLogout());
        }
      }

      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      } if (body.code === "bak-error-usu-001") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-error-usu-001"), "error");
        
      }
      if (body.code === "bak-error-usu-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-error-usu-002"), "error");
        
      }
      if (body.code === "BAK-ERROR-PASS-002") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
        
      }
      if (body.code === "bak-error-conn-001") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-error-conn-001"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-001") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

export const startChecking = () => {
  return async (dispatch) => {
    if (!localStorage.getItem("token")) {
      dispatch(checkingFinish());
    } else {
      const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_AUTH}`, "renew");
      const body = await resp.json();

       debugLogActions(':: authActions, startChecking', { 'body': body });

      if (body.ok) {
        localStorage.setItem("token", body.token);
        localStorage.setItem("token-init-date", new Date().getTime());

        dispatch(
          login({
            user_id: body.id,
            first_name: body.first_name,
            last_name: body.last_name,
            user_name: body.user_name,
          })
        );
      } else {
        dispatch(checkingFinish());
      }
    }
  };
};

export const startCheckingReloadSteps = () => {
  return async (dispatch) => {
    if (!localStorage.getItem("token")) {
      dispatch(checkingFinish());
    } else {
      const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_AUTH}`, "renew");
      const body = await resp.json();

       debugLogActions(':: authActions, startCheckingReloadSteps', { 'body': body });

      if (body.ok) {
        localStorage.setItem("token", body.token);
        localStorage.setItem("token-init-date", new Date().getTime());

        dispatch(
          login({
            user_id: body.id,
            first_name: body.first_name,
            last_name: body.last_name,
            user_name: body.user_name,
          })
        );

        dispatch(startGetRolesByUserId_Step2(body.id));
        dispatch(startLoadingConfigurations());
      } else {
        dispatch(checkingFinish());
      }
    }
  };
};

export const startCheckingReloadUnified = () => {
  return async (dispatch) => {
    if (!localStorage.getItem("token")) {
      dispatch(checkingFinish());
    } else {
      dispatch(setIsReLoadingMenuFromUrl())
      const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_AUTH}`, "renew");
      const body = await resp.json();

      debugLogActions(':: authActions, startCheckingReloadUnified', { 'body': body });

      if (body.ok) {
        localStorage.setItem("token", body.token);
        localStorage.setItem("token-init-date", new Date().getTime());
        dispatch(
          login({
            user_id: body.id,
            first_name: body.first_name,
            last_name: body.last_name,
            user_name: body.user_name,
          })
        );

        dispatch(startGetRolesMenusByUserId(body.id));
        dispatch(startLoadingConfigurations());
        dispatch(startLoadingHomeContentItems());
      } else {
        dispatch(checkingFinish());
      }
    }
  };
};

const checkingFinish = () => ({
  type: types.AUTH_CHEKING_FINISH_LOGIN_STATE,
});

const login = (user) => ({
  type: types.AUTH_LOGIN,
  payload: user,
});

export const startLogout = () => {
  return async (dispatch) => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        await fetchToken(
          `${const_routes.SCHEMA}`,
          `${const_routes.VERSIONV1}`,
          `${const_routes.ROUTE_AUTH}`,
          "logout",
          {},
          "POST"
        );
      } catch (error) {
        debugLogActions(":: authActions, startLogout", { error });
      }
    }
    clearActiveSpecialistRoleOnLogout();
    dispatch(logout());
    localStorage.clear();
  };
};

const logout = () => ({
  type: types.AUTH_LOGOUT,
});

export const userClean = () => ({
  type: types.AUTH_CLEAN,
});

export const confirmUserEmail = (token) => {
  return async (dispatch) => {

    const resp = await fetchNoToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_AUTH}`,
      "confirmation",
      { token },
      "POST"
    );
    const body = await resp.json();

     debugLogActions(':: authActions, confirmUserEmail', { 'body': body });

    if (body.ok) {
      dispatch(successConfirmationRegisterUser());
    } else {
      if (body.code === "bak-aut-tok-inv-conf-001") {
        
        dispatch(failedConfirmationRegisterUserError());
      }
      if (body.code === "bak-aut-tok-inv-conf-002") {
        
        dispatch(failedConfirmationRegisterUserValidation());
      }

    }
  };
};

const successConfirmationRegisterUser = () => ({
  type: types.AUTH_SUCCESS_CONFIRMATION_REGISTER,
});

const failedConfirmationRegisterUserError = () => ({
  type: types.AUTH_FAILED_CONFIRMATION_REGISTER_ERROR,
});

const failedConfirmationRegisterUserValidation = () => ({
  type: types.AUTH_FAILED_CONFIRMATION_REGISTER_VALIDATION,
});

export const confirmationRegisterClean = () => ({
  type: types.AUTH_CONFIRMATION_REGISTER_CLEAN,
});

export const changePasswordLastStep = (token, password, navigate) => {
  return async (dispatch) => {

    const resp = await fetchNoToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_AUTH}`,
      "update-password",
      { token, password },
      "POST"
    );
    const body = await resp.json();

     debugLogActions(':: authActions, changePasswordLastStep', { 'body': body });

    if (body.ok) {

      Swal.fire({
        title: 'Actulización exitosa',
        text: 'La actualización se realizo exitosamente!',
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Cerrar'
      }).then((result) => {
        if (result.isConfirmed) {
          /*Swal.fire(
            'Deleted!',
            'Your file has been deleted.',
            'success'
          );*/
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
          
        }
      });

    } else {
      if (body.code === "bak-aut-tok-inv-conf-001") {
        
        dispatch(failedConfirmationRegisterUserError());
      }
      if (body.code === "bak-aut-tok-inv-conf-002") {
        
        dispatch(failedConfirmationRegisterUserValidation());
      }
    }
  };
};


const successRegisterUser = () => ({
  type: types.AUTH_SUCCESS_REGISTER,
});

export const cleanRegisterUser = () => ({
  type: types.AUTH_CLEAN_REGISTER,
});